import { useState, useEffect, useCallback } from "react";
import fr from "./Fr";
import en from "./En";
import es from "./Es";

export type Language = "fr" | "en" | "es";
export type Translations = typeof fr;  

const LOCALES: Record<Language, Translations> = { fr, en, es };

const STORAGE_KEY = "app_language";

type Listener = (lang: Language) => void;
const listeners = new Set<Listener>();

function getStoredLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "fr" || stored === "en" || stored === "es") return stored;
  } catch {}
  return "fr";
}

function broadcastLanguage(lang: Language) {
  try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
  listeners.forEach((fn) => fn(lang));
}

export function useTranslation() {
  const [language, setLanguageState] = useState<Language>(getStoredLanguage);

  useEffect(() => {
    const handler: Listener = (lang) => setLanguageState(lang);
    listeners.add(handler);
    return () => { listeners.delete(handler); };
  }, []);

  const setLanguage = useCallback((lang: Language) => {
    broadcastLanguage(lang);   
  }, []);

  return {
    t: LOCALES[language] as Translations,
    language,
    setLanguage,
    availableLanguages: [
      { code: "fr" as Language, label: "Français" },
      { code: "en" as Language, label: "English"  },
      // { code: "es" as Language, label: "Español"  },
    ],
  };
}

